import { render, staticRenderFns } from "./zjdjxq.vue?vue&type=template&id=38e39222&scoped=true&"
import script from "./zjdjxq.vue?vue&type=script&lang=js&"
export * from "./zjdjxq.vue?vue&type=script&lang=js&"
import style0 from "./zjdjxq.vue?vue&type=style&index=0&id=38e39222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e39222",
  null
  
)

export default component.exports